<template>
  <div class="md:mb-10">
    <ShowEntryHeader />

   <!-- if isbns exist - show them -->
   <template v-if="showIsbn">
      <div class="grid grid-cols-1 pt-0 border-solid border border-gray-300">
        <p class="text-center font-semibold pt-3 pb-3 border-b bg-gray-100">
          {{ $t("Fullentry.IsbnNumbreSingleIsbn") }}
        </p>

        <div class="grid grid-cols-2 gap-0" :class="classForGridISBN">
          <template v-for="isbn in party.isbns" :key="isbn.isbnPrefix">
            <span
              class="px-2 py-2 bg-white even:bg-white odd:bg-white text-xs border"
              v-if="isbn.isbnPrefix"
              >{{ isbn.isbnPrefix }}
            </span>
          </template>
          <template v-for="isbn in party.isbns" :key="isbn.isbn">
            <span
              class="px-2 py-2 bg-white even:bg-white odd:bg-white text-xs border"
              v-if="isbn.isbn"
              >{{ isbn.isbn }}</span
            >
          </template>
        </div>
      </div>
    </template>   

    <br /><br />

    <div>{{ party }}</div>
  </div>
</template>

<script>
import { usePartyStore } from "../../stores/PartyStore";
//import ShowAdress from "./../../components/ShowAdress.vue";
import ShowEntryHeader from "./../../components/ShowEntryHeader.vue";
export default {
  name: "TheShortEntry",
  components: {
    ShowEntryHeader,
  },
  data() {
    return {
      partyStore: null,
    };
  },
  computed: {
    party() {
      return this.partyStore.party;
    },
    showIsbn() {
      return this.party.isbns.length > 0 ? true : false;
    },
    classForGridISBN() {
      if (this.party.isbns.length == 1) return "md:grid-cols-1 text-center";
      if (this.party.isbns.length == 2) return "md:grid-cols-2 text-center";
      if (this.party.isbns.length == 3) return "md:grid-cols-3 text-center";
      if (this.party.isbns.length == 4) return "md:grid-cols-4 text-center";
      if (this.party.isbns.length == 5) return "md:grid-cols-5 text-center";
      return "md:grid-cols-8";
    },    
  },
  async created() {
    this.partyStore = usePartyStore();
  },
};
</script>